import { render, staticRenderFns } from "./MaterialReport.vue?vue&type=template&id=f5440228&scoped=true"
import script from "./MaterialReport.vue?vue&type=script&lang=js"
export * from "./MaterialReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5440228",
  null
  
)

export default component.exports